import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import {
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { LoadingController, NavController, NavParams } from "ionic-angular";
import { CompanyWorkgroup } from "models/users/user-workgroups";
import { AccessControlService } from "../../../../app/access-control/access-control-service";
import { AuthService } from "../../../../app/auth/auth.service";
import { CompanyManagementService } from "../../../../providers/company-management-service/company-management-service";
import { StateManagementService } from "../../../../providers/state-management/state-management.service";
import { UsersService } from "../../../../providers/users-service/users.service";
import { WorkgroupPermissionDetail } from "../workgroup-permission-details/workgroup-permission-details";

@Component({
  selector: "work-groups-list",
  templateUrl: "work-groups-list.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WorkGroupsList),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => WorkGroupsList),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkGroupsList
  implements ControlValueAccessor, OnDestroy, OnInit, OnChanges
{
  // private spinnerCounter: number = 0;
  // private spinner: any = null;

  @Input()
  workgroups: CompanyWorkgroup[] = [];
  @Input()
  tenantId: number = 0;

  pagedWorkgroups: CompanyWorkgroup[] = [];
  pageLimit = 10;
  totalPages = 0;
  currentPage = 0;

  constructor(
    protected accessControlService: AccessControlService,
    protected authSvc: AuthService,
    protected navCtrl: NavController,
    protected navParams: NavParams,
    protected loader: LoadingController,
    protected userService: UsersService,
    protected companyManagementService: CompanyManagementService,
    protected stateManagementService: StateManagementService
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.workgroups && changes.workgroups.currentValue) {
      this.workgroups = changes.workgroups.currentValue as CompanyWorkgroup[];
      this.totalPages = Math.ceil(this.workgroups.length / 10);
      this.onPageChange(this.currentPage);
    }
  }
  writeValue(obj: any): void {}
  registerOnChange(fn: any): void {}
  registerOnTouched(fn: any): void {}
  setDisabledState?(isDisabled: boolean): void {}
  ngOnDestroy(): void {}
  ngOnInit(): void {}

  onPageChange(selectedPage: number) {
    this.loadPageData(selectedPage);
  }

  loadPageData(selectedPage) {
    this.currentPage = selectedPage;
    this.pagedWorkgroups =
      this.currentPage + 1 !== this.totalPages
        ? this.workgroups.slice(
            this.currentPage * this.pageLimit,
            (this.currentPage + 1) * this.pageLimit
          )
        : this.workgroups.slice(this.currentPage * this.pageLimit);
  }

  openDetails(workgroup: CompanyWorkgroup) {
    this.navCtrl.push(WorkgroupPermissionDetail, {
      workgroupId: workgroup.id,
      workgroupName: workgroup.name,
      isEditMode: !workgroup.isStandard,
      tenantId: this.tenantId,
    });
  }

  // addWorkgroup() {
  //     this.navCtrl.push(WorkgroupPermissionDetail, {

  //     })
  // }

  getWorkGroups() {
    // this.increaseSpinnerCount("Loading Work Groups...");
    // this.companyManagementService.getWorkGroups().subscribe(
    //     response => {
    //         // this.workgroupData = [response];
    //         this.decreaseSpinnerCount();
    //         this.workgroupData = response.map(x => {
    //             return {
    //                 name: x.name,
    //                 accessLevel: x.accessLevel || 'N/A',
    //                 memberCount: x.memberCount || 'N/A',
    //                 dateCreated: x.dateCreated || 'N/A',
    //                 id: x.id
    //             }
    //         });
    //         this.loadPageData(this.currentPage);
    //         this.totalPages = Math.ceil(this.workgroupData.length / 10);
    //     },
    //     err => {
    //         // TODO put an error message here
    //         this.decreaseSpinnerCount();
    //     }
    // )
  }
}



// WEBPACK FOOTER //
// ./src/pages/company/company-details/workgroup-management/work-groups-list.ts